var map = {
	"./Abhijit-with-Madan.jpg": "b082",
	"./Amsterdam-Cricket-Academy.png": "7884",
	"./B3-Cricket.png": "ae07",
	"./CGTN-africa.jpg": "d06a",
	"./CGTN.jpg": "5bd4",
	"./Callander-Cricket-Club.png": "5348",
	"./Claremont-School.png": "8615",
	"./Concordia-Cricket-Delft.png": "e9e5",
	"./Cricket-Club-Bloemendaal.png": "9444",
	"./Cricket-Mentoring.png": "f28d",
	"./Cutting-Edge-Coaching.png": "4a34",
	"./DJ-Coaching.png": "2150",
	"./Eliz.jpg": "fee1",
	"./Flag-of-Pakistan.jpg": "c6e1",
	"./Ilkley-Cricket-Club.png": "ab05",
	"./Ludimos-cricket-player.jpg": "c2f3",
	"./Nathan.jpg": "fa41",
	"./Spin-Bowling-Academy.png": "ce40",
	"./SportsFever360-Ludimos.jpg": "689d",
	"./SportsFever360.jpg": "67ef",
	"./The-Cricket-Academy.png": "fbf3",
	"./abhijit-khan-germany.jpg": "8cc6",
	"./abhijit-khan.jpg": "20ae",
	"./ai-ios.mp4": "3258",
	"./alberto.jpg": "a273",
	"./angelinvestmentnetwork.jpg": "dfd9",
	"./angelinvestmentnetwork.svg": "f209",
	"./app-store.png": "8998",
	"./app-store.svg": "4d1d",
	"./ashton.jpg": "4948",
	"./bluetulip.jpg": "f772f",
	"./ca-joins-ludimos.jpg": "9e3e",
	"./ca-square.jpg": "4e85",
	"./callum_croom.png": "3c0e",
	"./campaign/b2c-hero-1.png": "931f",
	"./campaign/b2c-hero-2.png": "1b81",
	"./campaign/campaign-image-1.png": "d898",
	"./campaign/campaign-image-2.png": "1615",
	"./campaign/campaign-image-3.png": "abc3",
	"./campaign/campaign-image-4.png": "6fec",
	"./charlotte.jpg": "92a4",
	"./club-image.jpg": "45fd",
	"./club.jpg": "5ac9",
	"./coach-image.jpg": "9907",
	"./coaching-cohort.jpg": "556c",
	"./congratulations.gif": "5c6a",
	"./cricket-argentina.jpg": "70e6",
	"./cricket-denmark.jpg": "b1f1",
	"./cricket-next.jpg": "18da",
	"./cricket-next.png": "6158",
	"./cricket-player.png": "b5fa",
	"./cs-joins-ludimos.jpg": "a37c",
	"./cs-square.jpg": "7987",
	"./customer-2.png": "7b31",
	"./customer-3.png": "ecb3",
	"./cutting-egde-coaching.png": "4ff3",
	"./danelle_oberholtzer.png": "435f",
	"./dave-nosworthy.jpg": "9a53",
	"./devices.mp4": "c518",
	"./drills.mp4": "59e5",
	"./drills.png": "35af",
	"./emma_charles.jpeg": "d7a9",
	"./facebook.png": "5bf0",
	"./favicon.ico": "a9b3",
	"./feature-visual-1.png": "4fc1",
	"./feature-visual-2.png": "e29d",
	"./feature-visual-3.png": "7e7a",
	"./feature-visual-4.png": "c1b4",
	"./feedback-ios.mp4": "1636",
	"./fica-germany.jpg": "5815",
	"./footer-wave.svg": "1b08",
	"./frank-van-rest.jpg": "c818",
	"./gandhi_jafta.jpeg": "c0aa",
	"./get-coach-bg.png": "b7e2",
	"./gio.jpg": "4192",
	"./google-play.png": "fec7",
	"./google-play.svg": "1b8a",
	"./hero-background.svg": "b4a2",
	"./hero-bg.jpg": "9f0b",
	"./hero-bg.svg": "c8de",
	"./hero-graph.png": "047b",
	"./hero-image-old.png": "d645",
	"./hero-image.png": "d2d7",
	"./image-hero.jpg": "cd60",
	"./instagram.png": "79f6",
	"./kailash.jpg": "9df6",
	"./karl.jpg": "6717",
	"./kncb-partners-with-ludimos.jpg": "1548",
	"./kncb-roland-ryan.jpg": "5cc6",
	"./kncb.png": "d6d7",
	"./lakshay.jpg": "3f5a",
	"./linkedin.png": "d6f3",
	"./logo.svg": "1ae4",
	"./ludimos-dashboard.png": "7147",
	"./madan.jpg": "d6fe",
	"./manuel.jpg": "2b1d",
	"./marketplace-image.jpg": "8bfe",
	"./marketplace.png": "3771",
	"./matt.jpg": "6f79",
	"./member.jpg": "6cd2",
	"./news/Beyond-the-nets.jpg": "ef64",
	"./news/Cricket-vs-Corona-Cricket-is-winning.jpg": "b03b",
	"./news/Dave-Nosworthy.jpg": "d88e",
	"./news/Overcame-this-obstacle.jpg": "642f",
	"./news/Smart-Cricket-in-a-Ludimos-Smart-Lane.jpg": "00dc",
	"./news/bowler.jpg": "3924",
	"./news/corona.jpg": "0ba9",
	"./news/net.jpg": "9204",
	"./news/obstacle.jpg": "7f22",
	"./news/purpose.jpg": "1a1f",
	"./news/reverse-sweep-1.png": "0789",
	"./news/reverse-sweep-2.jpg": "1461",
	"./news/reverse-sweep-3.jpg": "79be",
	"./news/reverse-sweep-4.jpg": "9384",
	"./news/reverse-sweep-5.jpg": "e0bd",
	"./news/reverse-sweep.jpg": "a023",
	"./news/smart-lane.jpg": "05ab",
	"./noah.jpg": "6a6c",
	"./northerns-cricket-union.jpg": "cd6e",
	"./parents-image.jpg": "5888",
	"./performance.mp4": "11f6",
	"./play-store.svg": "6079",
	"./player-image.jpg": "83a9",
	"./player.jpg": "a142",
	"./problem-illustration.png": "ef42",
	"./redback.png": "6101",
	"./riaan_boshoff.png": "269f",
	"./roberto.jpg": "b8ce",
	"./robyn_searle.jpg": "428d",
	"./robyn_searle_1.png": "e35b",
	"./route2media.jpg": "95aa",
	"./said.jpg": "6331",
	"./sam.jpg": "d1e9",
	"./sanjay-patel-1.jpg": "7738",
	"./serbia-joins-ludimos.jpg": "6dc1",
	"./sportageous.jpg": "5c7d",
	"./sportknowhowxl.jpg": "d9b6",
	"./sportstar.jpg": "4a96",
	"./swetha.jpg": "b030",
	"./tammo-beishuizen.jpg": "4b65",
	"./team-management.mp4": "333a",
	"./times-of-india.jpg": "0234",
	"./titans-hero.jpg": "7d7b",
	"./titans.jpg": "1576",
	"./titians-ludimos.jpg": "466a",
	"./twitter.png": "13a4",
	"./uk.png": "706a",
	"./user-1.jpg": "c785",
	"./user-10.jpg": "4aa3",
	"./user-2.jpg": "dfe6",
	"./user-3.jpg": "3ade",
	"./user-4.jpg": "8290",
	"./user-5.jpg": "94da",
	"./user-6.jpg": "52b2",
	"./user-7.jpg": "b782",
	"./user-8.jpg": "39e8",
	"./user-9.jpg": "1760",
	"./user1.jpg": "5f97",
	"./user2.jpg": "95f5",
	"./user3.jpg": "85dc",
	"./user4.jpg": "8748",
	"./vra-cricket.png": "b472",
	"./wave.svg": "d0e0",
	"./websummit.png": "03b6",
	"./white-customer-1.png": "d8a4",
	"./white-customer-2.png": "157b",
	"./white-customer-3.png": "7edb",
	"./white-customer-4.png": "4252",
	"./white-customer-5.png": "9a52",
	"./xander_venter.png": "5b89",
	"./yoan.jpg": "dcdf",
	"./youtube.png": "f599"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";